import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const DocumentVersions = ({ reference, title, documentStatusName, projectType, traceability, traceabilityLoading, isHidden }) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const dropdownRef = useRef(null)
  
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  
  const handleClickOutside = (event) => {
    if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  
  if (isHidden) {
    return (<span/>)
  }

  const itemUrl = (item) => {
    return projectType ?
           `/portfolio/${item.project_id}/${item.type}/${item.id}` :
           `/${item.type}/${item.id}`
  }
  
  const label = projectType ?
                (<span>All versions of this document <i>within this</i> {projectType}.</span>) :
                "All versions of this document."

  return (
    <div className="dropdown" style={{position: 'relative', display: 'inline-block', marginLeft: '20px'}}  ref={dropdownRef}>
      <button
          className="btn btn-xs btn-light"
          onClick={toggleDropdown}
      >
        Versions <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} style={{fontSize: '0.6em', opacity: 0.6, verticalAlign: 'middle', marginLeft: '4px'}}></i>
      </button>

      {isOpen && (
         <div className="dropdown-menu" style={{display: 'block', position: 'absolute', backgroundColor: '#fff', border: '1px solid #ccc', boxShadow: '0 6px 12px rgba(0,0,0,.175)', zIndex: 1000, minWidth: '400px'}}>
           <h3 className="search-results" style={{paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '10px'}}>
             <small className="text-muted" style={{fontSize: '10.5px'}}>
               {label}
             </small>
           </h3>
           
           {traceabilityLoading ? (
              <div className="text-center m-t" style={{fontSize: '14px', color: '#676a6c', minHeight: '50px'}}>
                <i className="fa fa-spinner fa-spin"></i> Loading...
              </div>
            ) : traceability && traceability.versions ? (
              <ul className="search-results">
                {traceability.versions.previous && traceability.versions.previous.slice().reverse().map((version) => (
                   <li className="search-results" key={version.id}>
                     <Link to={itemUrl(version)}>
                       {version.reference} {version.title}
                     </Link><br/>
                     <small className="search-results">Status: {version.document_status?.name}</small>

                   </li>
                 ))}
                <li className="search-results">
                  <span style={{display: 'block', clear: 'both', whiteSpace: 'nowrap'}}>
                    {reference} {title}
                  </span>
                  <small className="search-results">Status: {documentStatusName}</small>

                </li>
                {traceability.versions.next && traceability.versions.next.map((version) => (
                   <li className="search-results" key={version.id}>
                     <Link to={itemUrl(version)}>
                       {version.reference} {version.title}
                     </Link><br/>
                     <small className="search-results">Status: {version.document_status?.name}</small>
                   </li>
                 ))}
              </ul>
            ) : (
              <ul className="search-results">
                <li className="search-results">
                  <span style={{display: 'block', clear: 'both', whiteSpace: 'nowrap'}}>
                    {reference} - {title}
                  </span>
                  <small className="search-results">Status: {documentStatusName}</small>
                </li>
              </ul>
            )}
         </div>
       )}
    </div>
  );
};

export default DocumentVersions;
